<script>
  export let day = "";
  export let classes;
  export let url;
  export let hintTop;
  export let hintBottom;
</script>

<style>
  .kalendar--cell {
    position: relative;
    display: flex;
    flex: 1 0 1%;
    height: 58px;
    margin: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 7px;
    border-radius: var(--main-border-radius, 7px);
    /* background-color: #f2f2f2;
    background-color: var(--main-inner-card-background-color, #f2f2f2); */
    text-align: center;
    font-size: 22px;
    color: var(--main-inner-card-foreground-color, #797c86);
    user-select: none;
  }

  .kalendar--cell.__weekend {
    font-weight: 600;
  }

  .kalendar--cell.__weekend.__active.__selected {
    background-color: #ddaf54;
  }
  .kalendar--cell.__weekend.__active.__selected:hover {
    background-color: #ddaf54;
  }

  .kalendar--cell.__active {
    background-color: var(--main-secondary-background-color, #51716d);
    color: #333;
    color: var(--main-secondary-foreground-color, #fff);
    opacity: 1;
  }

  .kalendar--cell.__active:hover {
    background-color: var(--main-primary-background-color, #ddaf54);
    filter: contrast(1.1);
  }

  .kalendar--cell.__active:hover,
  .kalendar--cell-hint__bottom {
    color: var(--main-primary-foreground-color);
  }

  .kalendar--cell.__active.__selected {
    background-color: var(--main-primary-background-color, #ddaf54);
  }

  .kalendar--cell.__active.__selected:hover {
    opacity: 1;
  }
  .kalendar--cell.__active.__selected,
  .kalendar--cell-hint__bottom {
    color: #333;
    color: var(--main-primary-foreground-color, #333);
  }

  .kalendar--cell.__prev,
  .kalendar--cell.__next {
    opacity: 0.6;
  }

  .kalendar--cell-hint__top,
  .kalendar--cell-hint__bottom {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 9px;
    font-weight: 500;
    line-height: 20px;
    text-transform: uppercase;
  }

  .kalendar--cell-hint__top {
    top: 0;
  }

  .kalendar--cell-hint__bottom {
    bottom: 0;
    color: #c82814;
  }

  .kalendar--cell-date {
    position: relative;
    display: flex;
    width: 100%;
    padding: 5px;
    justify-content: center;
    align-items: center;
    color: inherit;
    z-index: 1;
    text-decoration: none;
  }

  .kalendar--cell-date:hover {
    text-decoration: none;
    color: inherit;
  }
</style>

<div class="kalendar--cell {classes} isolate">
  {#if hintTop}
    <div class="kalendar--cell-hint__top">{hintTop}</div>
  {/if}

  {#if url}
    <a href={url} class="kalendar--cell-date">{day}</a>
  {:else}
    <div class="kalendar--cell-date">{day}</div>
  {/if}

  {#if hintBottom}
    <div class="kalendar--cell-hint__bottom">{hintBottom}</div>
  {/if}
</div>
